export const iconFontAwesomeDisasterCrisisBurst = (
	<i className="fa-solid fa-burst"></i>
);
